<template>
  <div
    ref="headerRef"
    :class="{ 'mt-24': tipoOpcao.tradicional }"
    class="flex flex-nowrap bg-200 w-full border-b border-b-neutral-100/10 overflow-x-auto hide-scrollbar"
  >
    <div
      class="px-24 shrink-0 w-[var(--pergunta-width)] py-4 sticky left-0 top-0 z-10 bg-200"
      :class="{
        isCheckbox: tipoOpcao?.checkbox,
      }"
    >
      <h3 class="text-headline-3 text-neutral-70">
        {{ t('maturityLevels') }}
      </h3>
    </div>
    <template v-if="!tipoOpcao.tradicional">
      <div class="flex items-center grid-cols-opcoes w-full">
        <template
          v-for="opcao /*  i */ in alternativas[0]?.itemopcao_set"
          :key="opcao.id"
        >
          <h3
            class="text-headline-3 text-neutral-70 px-24 w-full text-center"
          >
            {{ opcao.opcao_titulo_readonly }}
          </h3>
        </template>
      </div>
    </template>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/** @typedef {import('js/vue/types/pergunta.ts').Alternativaset[]} Alternativas */

/** @type {{ alternativas: Alternativas }} */
const props = defineProps({
  alternativas: Array,
  tipoOpcao: Object,
})

const headerRef = ref(null)

defineExpose({
  headerRef,
})
</script>

<style lang="scss" scoped></style>
